import React from "react";
import "./Portfolio.css";

const Portfolio = () => {
  return (
    <main className="portfolio_container">
      <div className="gallery_wrapper">
        <div className="column">
          <img
            src={require("../../images/portfolio/2023-03-31-Riya-KAR07511.jpg")}
            alt=""
          />
          <img
            src={require("../../images/portfolio/2023-04-16-ibbani-KAR07700.jpg")}
            alt=""
          />
          <img
            src={require("../../images/portfolio/2023-01-12-ashwitha-KAR02044.jpg")}
            alt=""
          />
          <img
            src={require("../../images/portfolio/2023-02-04-Riya-KAR03787.jpg")}
            alt=""
          />
          <img
            src={require("../../images/portfolio/2023-02-25-nethra-KAR05093.jpg")}
            alt=""
          />
          <img
            src={require("../../images/portfolio/2023-03-17-vatz-KAR06308.jpg")}
            alt=""
          />
          <img
            src={require("../../images/portfolio/2023-03-31-Riya-KAR07646.jpg")}
            alt=""
          />
          <img src={require("../../images/portfolio/img1.jpg")} alt="" />
          <img src={require("../../images/portfolio/img7.jpg")} alt="" />
          <img src={require("../../images/portfolio/img36.jpg")} alt="" />
          <img src={require("../../images/portfolio/img37.jpg")} alt="" />
          <img src={require("../../images/portfolio/img38.jpg")} alt="" />
          <img src={require("../../images/portfolio/img39.jpg")} alt="" />
        </div>

        <div className="column">
          <img
            src={require("../../images/portfolio/2023-04-16-ibbani-KAR07784.jpg")}
            alt=""
          />
          <img
            src={require("../../images/portfolio/2023-03-31-Riya-KAR07269.jpg")}
            alt=""
          />
          <img
            src={require("../../images/portfolio/2023-04-16-ibbani-KAR07816.jpg")}
            alt=""
          />
          <img
            src={require("../../images/portfolio/2023-01-12-ashwitha-KAR02096.jpg")}
            alt=""
          />
          <img
            src={require("../../images/portfolio/2023-02-04-Riya-KAR03851.jpg")}
            alt=""
          />
          <img
            src={require("../../images/portfolio/2023-02-25-nethra-KAR05117.jpg")}
            alt=""
          />
          <img
            src={require("../../images/portfolio/2023-03-31-Riya-KAR07594.jpg")}
            alt=""
          />

          <img src={require("../../images/portfolio/img2.jpg")} alt="" />
          <img
            src={require("../../images/portfolio/2023-08-06-rakshitha-KAR08950.jpg")}
            alt=""
          />
          <img src={require("../../images/portfolio/img15.jpg")} alt="" />
          <img src={require("../../images/portfolio/img16.jpg")} alt="" />
          <img
            src={require("../../images/portfolio/2023-09-11-riya-KAR00363.jpg")}
            alt=""
          />
          <img src={require("../../images/portfolio/img40.jpg")} alt="" />
        </div>
        <div className="column">
          <img
            src={require("../../images/portfolio/2023-03-31-Riya-KAR07329.jpg")}
            alt=""
          />
          <img
            src={require("../../images/portfolio/2023-02-04-Riya-KAR03720.jpg")}
            alt=""
          />
          <img
            src={require("../../images/portfolio/2023-02-04-Riya-KAR03739.jpg")}
            alt=""
          />
          <img
            src={require("../../images/portfolio/2023-02-04-Riya-KAR03773.jpg")}
            alt=""
          />
          <img
            src={require("../../images/portfolio/2023-02-04-Riya-KAR04049.jpg")}
            alt=""
          />
          <img
            src={require("../../images/portfolio/2023-03-17-vatz-KAR06199.jpg")}
            alt=""
          />
          <img
            src={require("../../images/portfolio/2023-03-31-Riya-KAR07619.jpg")}
            alt=""
          />
          <img
            src={require("../../images/portfolio/2023-04-16-ibbani-KAR07831.jpg")}
            alt=""
          />
          <img
            src={require("../../images/portfolio/2023-08-06-rakshitha-KAR08812.jpg")}
            alt=""
          />
          <img
            src={require("../../images/portfolio/2023-09-11-riya-KAR00359.jpg")}
            alt=""
          />
          <img src={require("../../images/portfolio/img34.jpg")} alt="" />
          <img src={require("../../images/portfolio/img35.jpg")} alt="" />
          <img src={require("../../images/portfolio/img46.jpg")} alt="" />
        </div>
      </div>
    </main>
  );
};

export default Portfolio;
